import {
  MOCK_DATA_PRE_SUBSCRIPTION_DEFAULT,
  MOCK_DATA_PRE_SUBSCRIPTION_NO_COUNTDOWN,
  MOCK_DATA_PRE_SUBSCRIPTION_NO_OFFER,
} from "./MOCK_DATA";

export const getPassData = async () =>
  await fetch(`${process.env.NEXT_PUBLIC_HOST}/umbraco/botb/botbdynamiccontent/GetBotBPassData`);

export const getAvailableSubscriptions = async (abortController?: AbortController) =>
  await fetch(`${process.env.NEXT_PUBLIC_SUBSCRIPTION_HOST}/api/packages`, {
    signal: abortController?.signal,
  });

export const getBotbPassCompetitions = () =>
  fetch(`${process.env.NEXT_PUBLIC_HOST}/umbraco/00000001/StripeSubscriptionServerSide/GetBotbPassCompetitions`, {
    credentials: "include",
  });

export const getBotbPrizeStraplineTexts = () =>
  fetch(`${process.env.NEXT_PUBLIC_HOST}/umbraco/00000001/app/GetPrizeStraplineTexts`);

export const getSubscriptionData = (useMockData = false, mockType?: "default" | "noOffer" | "noCountdown") => {
  if (useMockData) {
    switch (mockType) {
      case "default":
        return Promise.resolve({ json: () => Promise.resolve(MOCK_DATA_PRE_SUBSCRIPTION_DEFAULT) });
      case "noOffer": {
        return Promise.resolve({ json: () => Promise.resolve(MOCK_DATA_PRE_SUBSCRIPTION_NO_OFFER) });
      }
      case "noCountdown": {
        return Promise.resolve({ json: () => Promise.resolve(MOCK_DATA_PRE_SUBSCRIPTION_NO_COUNTDOWN) });
      }
    }
  }
  return fetch(`${process.env.NEXT_PUBLIC_HOST}/umbraco/00000001/app/GetPreSubscriptionModal`, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const getWinnersData = () => {
  return fetch(`${process.env.NEXT_PUBLIC_HOST}/umbraco/surface/WinnersSurface/GetBotbPassWinners`);
};
